import React from 'react';

export const StylesPages = () => {
    return <div>StylesPages</div>;
};
